import '@/style/index.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import http from './utils/ajax'
import Vant from 'vant'
import '@/plugins/index'
import 'vant/lib/index.css'
import './intercept'


import VueQuillEditor from 'vue-quill-editor'

// 引入 Quill 样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 注册组件
Vue.use(VueQuillEditor)

import { Toast } from 'vant'

Vue.prototype.$http = http
Vue.prototype.$toast = Toast
Vue.config.productionTip = false

Vue.use(Vant)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
